<route>
{
  "meta": {
    "requiresAuth": true
  }
}
</route>

<template>
  <div>
    Waiting...
    <div id="myspinner"></div>
  </div>
</template>

<script>
import Amplify from 'aws-amplify';
import { Spinner } from '@/services/spinner';
import userInfo from '@/services/userInfo';
import utils from '@/services/utils';
// import twitterAuth from '@/services/twitterAuth';
import store from '@/store';

export default {
  name: 'verify',

  async mounted() {
    // based on:
    // verificationbucket-dev.s3-website-us-east-1.amazonaws.com/verify.js

    // Spinner opts
    // const opts = {
    //   lines: 13, // The number of lines to draw
    //   length: 38, // The length of each line
    //   width: 17, // The line thickness
    //   radius: 45, // The radius of the inner circle
    //   scale: 1, // Scales overall size of the spinner
    //   corners: 1, // Corner roundness (0..1)
    //   color: '#ffffff', // CSS color or array of colors
    //   fadeColor: 'transparent', // CSS color or array of colors
    //   speed: 1, // Rounds per second
    //   rotate: 0, // The rotation offset
    //   animation: 'spinner-line-fade-quick', // The CSS animation name for the lines
    //   direction: 1, // 1: clockwise, -1: counterclockwise
    //   zIndex: 2e9, // The z-index (defaults to 2000000000)
    //   className: 'spinner', // The CSS class to assign to the spinner
    //   top: '50%', // Top position relative to parent
    //   left: '50%', // Left position relative to parent
    //   shadow: '0 0 1px transparent', // Box-shadow for the lines
    //   position: 'absolute', // Element positioning
    // };

    const target = document.getElementById('myspinner');
    new Spinner().spin(target);

    const urlParams = new URLSearchParams(window.location.search);
    // const encoded = urlParams.get('data');
    const code = urlParams.get('code');

    const config = Amplify.configure({});
    // console.log('Current config: ', config);

    // if (!encoded) {
    //   console.log('Cant verify - parameters not found');
    //   return;
    // }
    // const decoded = JSON.parse(atob(encoded));
    // console.log('Decoded: ', decoded);
    // const { userName/* , redirectUrl, clientId , region */ } = decoded;

    const session = await Amplify.Auth.currentSession();

    const params = {
      AccessToken: session.getAccessToken().getJwtToken(),
      AttributeName: 'email',
      Code: code,
    };

    // AWS.config.region = region;

    // eslint-disable-next-line no-undef
    const cogISP = new AWS.CognitoIdentityServiceProvider({
      region: config.aws_cognito_region,
    });

    const cmp = this;

    cogISP.verifyUserAttribute(params, async (err, data) => {
      // console.log('cogISP.verifyUserAttribute: ', err, data);
      if (err) {
        utils.setStatusMsg(cmp, `Unexpected error: ${err.message}`);
        console.log('Error with verifyUserAttribute', err);
        return;
      }
      if (data) {
        // console.log('Received from verifyUserAttribute: ', data);
        // twitterAuth.clearEmailNeedsVerification();
        const app = utils.app(cmp);
        if (app) {
          await userInfo.syncUserEmail(store.state.user.name);
          utils.setStatusMsg(cmp, 'E-mail verified!');
        }
      }
      cmp.$router.push('/home');
      // window.location.replace(config.oauth.redirectSignIn);
    });
  },
};
</script>

<style>
@keyframes spinner-line-fade-more {
  0%,
  100% {
    opacity: 0; /* minimum opacity */
  }
  1% {
    opacity: 1;
  }
}
@keyframes spinner-line-fade-quick {
  0%,
  39%,
  100% {
    opacity: 0.25; /* minimum opacity */
  }
  40% {
    opacity: 1;
  }
}
@keyframes spinner-line-fade-default {
  0%,
  100% {
    opacity: 0.22; /* minimum opacity */
  }
  1% {
    opacity: 1;
  }
}
</style>
